<nav
  *ngIf="tabs().length"
  class="flex items-center gap-1 px-5 bg-surface border-b border-border overflow-x-auto"
>
  <a
    *ngFor="let tab of tabs()"
    [routerLink]="tab.route"
    routerLinkActive="text-action border-action font-semibold"
    class="relative shrink-0 px-3 py-3 text-[13px] font-medium text-ink-secondary hover:text-ink-primary
           border-b-2 border-transparent transition-colors whitespace-nowrap"
  >
    {{ tab.label }}
  </a>
</nav>
